<template>
  <div class="hello">
    <v-app-bar color="yellow darken-3" dense dark>
      <v-avatar tile><img src="../assets/logo-draft-colored.svg"></v-avatar>
      <v-toolbar-title>A3CT GDPR Webapp</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="login" v-if="!$store.getters.isAuthenticated">Sign In</v-btn>
      <v-btn color="primary" @click="logout" v-if="$store.getters.isAuthenticated">Sign Out</v-btn>
      <template v-slot:extension>
        <v-tabs align-with-title>
          <v-tab :to="`exclusion`" :disabled="!$store.getters.isAuthenticated">Exclusion</v-tab>
          <v-tab :to="`extract`" :disabled="!$store.getters.isAuthenticated">Extract</v-tab>
          <v-tab :to="`dashboard`" :disabled="!$store.getters.isAuthenticated">Dashboard</v-tab>
          <v-tab :to="`uploadfile`" :disabled="!$store.getters.isAuthenticated">Uploadfile</v-tab>
        </v-tabs>
      </template>
    </v-app-bar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'Authenticate',
  computed: {
    ...mapGetters(['isAuthenticated, isAuthenticated_gdpr, isAuthenticated_dashboard']),
  },
  methods: {
    ...mapActions(['login', 'logout', 'checkAuthentication']),
  },
  created() {
    if (!this.$store.getters.isAuthenticated) {
      this.alert = true;
    }
  },
  async mounted() {
    await this.$store.dispatch('checkAuthentication');
    // Handle further logic based on the updated state if needed.
  },
  data() {
    return {
      alert: false,
    };
  },
};
</script>

<style scoped>
/* Your styles here */
</style>
